<template>
    <header class="site-header">
        <div class="container">
        <dl class="row">
            <dl class="col-sm-3">
                <img class="img-fluid" src="../assets/logo-camtil-branco.png"/>
            </dl>
            <dl  v-if="$auth.check()" class="col-sm-9">                
                <div class="user_name">
                 <b-dropdown id="dropdown-1" :text="buttonTitle" class="logout btn-info m-md-2">
                    <b-dropdown-item v-on:click="doLogout"><i class="fa fa-lock" /> Logout</b-dropdown-item>
                </b-dropdown>
                </div>

            </dl>
        </dl>
        </div>
    </header>
</template>

<script>
export default {
    name: 'HeaderFront',
    data(){
        return{
            buttonTitle: this.$auth.user().name 
        }
    },
    components: {
         //AppHeaderDropdown,
    },
    methods: {
        doLogout() {
            this.$auth
                .logout({
                    //makeRequest: true,
                    redirect: {name: 'login'},
                });
        }

    }
}
</script>

<style>

    header.site-header {
        background-image: url('../assets/header-camtil-mini.jpg');       
        height: 380px;
        -webkit-background-size: cover;
        -moz-background-size: cover;
        -o-background-size: cover;
        background-size: cover;
     /* background-image:url("images/webheader.jpg"); */
    }

    header img{
        position: absolute;
        top: 60px;
    }

    .user_name{
        color: white;
        text-align: right;
    }
    .grey_card
    {
        background: #dfdddd !important;
        margin-bottom: 20px !important;
    }

    .logout .btn-secondary,
    .logout .btn-secondary:hover{
        background: transparent !important;
        border-color: transparent !important;
    }
    /* #dropdown-1{
        background: transparent;
    } */
    
</style>

